import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { getProjectPortfolio } from "../../../api/projectApi";

const ProjectFinanceSelect = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [options, setOptions] = useState([]);
  const [projectsData, setProjectsData] = useState([]);

  useEffect(() => {
    const loadProjects = async () => {
      try {
        setIsLoading(true);
        const projects = await getProjectPortfolio();
        // Сохраняем полные данные проектов для проверки departments.id
        setProjectsData(projects || []);
        const opts = (projects || []).map((p) => ({
          value: p.id,
          label: `${p.cipher_pilot ? p.cipher_pilot + " — " : ""}${
            p.name || "Без названия"
          }`,
        }));
        setOptions(opts);
      } catch (e) {
        setError(e?.message || "Не удалось загрузить проекты");
      } finally {
        setIsLoading(false);
      }
    };
    loadProjects();
  }, []);

  const handleProjectSelect = (opt) => {
    if (!opt) return;

    // Находим полные данные проекта
    const project = projectsData.find((p) => p.id === opt.value);

    // Проверяем department_id для определения типа проекта
    const departmentId =
      project?.department_id ||
      project?.project_type?.department_id ||
      (project?.departments && project.departments[0]?.id);

    // Также проверяем по названию проекта (если содержит "_ЭП_" или заканчивается на "_ЭП")
    const nameContainsEP =
      project?.name &&
      (project.name.includes("_ЭП_") ||
        project.name.includes(" ЭП ") ||
        project.name.endsWith("_ЭП"));

    const isSketchDesign = departmentId === 4 || nameContainsEP;

    if (isSketchDesign) {
      // Перенаправляем на страницы финансов ЭП проектов
      navigate(`/projects/sketch-design/finance/${opt.value}`);
    } else {
      // Перенаправляем на страницы финансов РП проектов
      navigate(`/projects/finance/${opt.value}`);
    }
  };

  return (
    <div style={{ maxWidth: 720, margin: "40px auto", padding: "0 16px" }}>
      <h2 style={{ marginBottom: 16 }}>
        Выберите проект для просмотра финансов
      </h2>
      {error && <div style={{ color: "red", marginBottom: 12 }}>{error}</div>}
      <Select
        isLoading={isLoading}
        options={options}
        placeholder="Начните вводить название или шифр проекта..."
        onChange={handleProjectSelect}
        isClearable
      />
    </div>
  );
};

export default ProjectFinanceSelect;
